import { OrganizationLevelService } from '../../../services/organizationLevel.service';
import { CustomEntity } from './../../../models/customEntity.model';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { UserProfile } from 'src/app/models/userProfile.model';
import { SensorAssignment } from 'src/app/models/sensorAssignment.model';
import { SensorAssignmentService } from 'src/app/services/sensorAssignment.service';
import { ActivatedRoute } from '@angular/router';
import { CustomEntityService } from 'src/app/services/customEntity.service';
import { DateFormatService } from 'src/app/services/dateFormat.service';
import { OrganizationLevel } from 'src/app/models/organizationLevel.model';

@Component({
  standalone: false,
  selector: "app-report-header",
  templateUrl: "./report-header.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./report-header.component.scss"]
})
export class ReportHeaderComponent implements OnInit {
  constructor(
    private userService: UserService,
    private sensorAssignmentService: SensorAssignmentService,
    private route: ActivatedRoute,
    private customEntityService: CustomEntityService,
    private organizationService: OrganizationLevelService,
    private dateFormatService: DateFormatService
  ) { }

  ngOnInit(): void {
    this.initialize();
  }

  userData: UserProfile;
  today = new Date();
  sensorAssignmentData: SensorAssignment;
  formattedRange = '';
  sensorAssignmentId: string;
  customEntity: CustomEntity;
  organizationLevel: OrganizationLevel;

  private initialize() {
    this.userService.getCurrentUserProfile().subscribe((data) => {
      this.userData = data;
    });
    this.sensorAssignmentId = this.route.snapshot.params.id;
    this.loadSampleDetails(this.sensorAssignmentId);
  }

  private loadSampleDetails(id: string | undefined) {
    this.sensorAssignmentService.getById(id).subscribe((data) => {
      this.sensorAssignmentData = data;
      this.formattedRange = this.formatDateTime(data?.startDate as number, data?.endDate as number | null);
      this.getCustomEntity(this.sensorAssignmentData.endPointId);
    });
  }

  private getCustomEntity(id: string | undefined) {
    this.customEntityService.getCustomEntity(id).subscribe((data) => {
      this.customEntity = data;
      this.getOrganizationLevel(this.customEntity.organizationLevelId);
    });
  }

  private getOrganizationLevel(id: string | undefined) {
    this.organizationService.getById(id).subscribe((data) => {
      this.organizationLevel = data;
    });
  }

  formatDateTime(
    startDate: number | undefined,
    endDate: number | null | undefined
  ): string {
    if (!startDate) {
      return "";
    }

    const startFormatted = this.dateFormatService.formatTimestampToString(startDate);

    if (!endDate) {
      return `${startFormatted} - -`;
    }

    const sameDay =
      this.dateFormatService.formatTimestampToString(startDate, this.dateFormatService.canonicalDateFormat) ===
      this.dateFormatService.formatTimestampToString(endDate, this.dateFormatService.canonicalDateFormat);

    const endFormatted = this.dateFormatService.formatTimestampToString(
      endDate,
      sameDay ? this.dateFormatService.userTimeFormat : this.dateFormatService.userDateWithTimeFormat
    );

    return `${startFormatted} - ${endFormatted}`;
  }
}
